import { DEFAULT_LANG } from "../../constants";

export const defaultLang = DEFAULT_LANG;
